"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyStimulus = exports.generateImageChoices = void 0;
exports.handleButtonFeedback = handleButtonFeedback;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const __1 = require("../../..");
const helpers_1 = require("../../shared/helpers");
const trials_1 = require("../../shared/trials");
const taskSetup_1 = require("../../taskSetup");
const taskStore_1 = require("../../../taskStore");
const staggerButtons_1 = require("../../shared/helpers/staggerButtons");
const helpers_2 = require("../../shared/helpers");
const displayDebugInfo_1 = require("../../shared/helpers/displayDebugInfo");
const replayButtonHtmlId = 'replay-btn-revisited';
let incorrectPracticeResponses = [];
let startTime;
const generateImageChoices = (choices) => {
    return choices.map((choice) => {
        const imageUrl = __1.mediaAssets.images[(0, helpers_1.camelize)(choice)];
        return `<img src=${imageUrl} alt=${choice} />`;
    });
};
exports.generateImageChoices = generateImageChoices;
function enableBtns(btnElements) {
    btnElements.forEach((btn) => btn.removeAttribute('disabled'));
}
function handleButtonFeedback(btn, cards, isKeyBoardResponse, responsevalue, correctAudio) {
    var _a;
    const choice = ((_a = btn === null || btn === void 0 ? void 0 : btn.parentElement) === null || _a === void 0 ? void 0 : _a.id) || '';
    const answer = (0, taskStore_1.taskStore)().correctResponseIdx.toString();
    const isCorrectChoice = choice.includes(answer);
    let feedbackAudio;
    if (isCorrectChoice) {
        btn.classList.add('success-shadow');
        feedbackAudio = __1.mediaAssets.audio[correctAudio];
    }
    else {
        btn.classList.add('error-shadow');
        feedbackAudio = __1.mediaAssets.audio.feedbackTryAgain;
        // renable buttons
        setTimeout(() => enableBtns(cards), 500);
        incorrectPracticeResponses.push(choice);
    }
    function finishTrial() {
        taskSetup_1.jsPsych.finishTrial({
            response: choice,
            incorrectPracticeResponses,
            button_response: !isKeyBoardResponse ? responsevalue : null,
            keyboard_response: isKeyBoardResponse ? responsevalue : null,
        });
    }
    const correctAudioConfig = {
        restrictRepetition: {
            enabled: true,
            maxRepetitions: 2,
        },
        onEnded: finishTrial,
    };
    const incorrectAudioConfig = {
        restrictRepetition: {
            enabled: false,
            maxRepetitions: 2,
        },
    };
    helpers_1.PageAudioHandler.stopAndDisconnectNode(); // disconnect first to avoid overlap
    isCorrectChoice
        ? helpers_1.PageAudioHandler.playAudio(feedbackAudio, correctAudioConfig)
        : helpers_1.PageAudioHandler.playAudio(feedbackAudio, incorrectAudioConfig);
}
const legacyStimulus = (trial) => {
    return {
        type: plugin_html_multi_response_1.default,
        data: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            let isPracticeTrial = stim.assessmentStage === 'practice_response';
            return {
                save_trial: stim.assessmentStage !== 'instructions',
                assessment_stage: stim.assessmentStage,
                // not for firekit
                isPracticeTrial: isPracticeTrial,
            };
        },
        stimulus: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            let prompt = (0, helpers_1.camelize)(stim.audioFile);
            if ((0, taskStore_1.taskStore)().heavyInstructions &&
                stim.assessmentStage !== 'practice_response' &&
                stim.trialType !== 'instructions') {
                prompt += 'Heavy';
            }
            const t = (0, taskStore_1.taskStore)().translations;
            return `<div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <div class="lev-row-container instruction">
          <p>${t[prompt]}</p>
        </div>

        ${stim.image && !Array.isArray(stim.image)
                ? `<button class='image-medium' disabled>
            <img 
              src=${__1.mediaAssets.images[(0, helpers_1.camelize)(stim.image)]} 
              alt=${stim.image}
            />
          </div>`
                : ''}
        
        ${stim.image && Array.isArray(stim.image)
                ? `<div class='lev-stim-content' style="flex-direction: column;">
            ${stim.trialType === 'something-same-1'
                    ? `
              <div style="visibility: hidden;">
                <button class='image no-pointer-events'>
                  <img 
                    src=${__1.mediaAssets.images[(0, helpers_1.camelize)(stim.image[0])]} 
                    alt=${stim.image[0]}
                    class='top-image'
                  />
                </button>
              </div>
              `
                    : ''}
            <div class='lev-response-row multi-4'>
              ${stim.image
                    .map((shape) => {
                    return `<button class='image-medium no-pointer-events' style='margin: 0 4px'>
                          <img 
                            src=${__1.mediaAssets.images[(0, helpers_1.camelize)(shape)]} 
                            alt=${shape} 
                          />
                      </button>`;
                })
                    .join('')}
            </div>
          </div>`
                : ''}
      </div>`;
        },
        prompt_above_buttons: true,
        button_choices: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            if (stim.trialType === 'instructions' || stim.trialType == 'something-same-1') {
                return ['OK'];
            }
            else {
                const randomize = !!stim.answer ? 'yes' : 'no';
                // Randomize choices if there is an answer
                const { choices } = (0, helpers_1.prepareChoices)(stim.answer, stim.distractors, randomize);
                return (0, exports.generateImageChoices)(choices);
            }
        },
        button_html: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const buttonClass = stim.trialType === 'instructions' || stim.trialType === 'something-same-1' ? 'primary' : 'image-medium';
            return `<button class="${buttonClass}">%choice%</button>`;
        },
        response_ends_trial: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            return !(stim.trialType === 'test-dimensions' ||
                (stim.assessmentStage === 'practice_response' && stim.trialType !== 'something-same-1'));
        },
        on_load: () => {
            startTime = performance.now();
            const stimulus = trial || (0, taskStore_1.taskStore)().nextStimulus;
            let audioFile = stimulus.audioFile;
            if ((0, taskStore_1.taskStore)().heavyInstructions &&
                stimulus.assessmentStage !== 'practice_response' &&
                stimulus.trialType !== 'instructions') {
                audioFile += '-heavy';
            }
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(audioFile)]);
            const pageStateHandler = new helpers_1.PageStateHandler(audioFile, true);
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
            const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
            buttonContainer.classList.add('lev-response-row');
            buttonContainer.classList.add('multi-4');
            const trialType = stimulus.trialType;
            const assessmentStage = stimulus.assessmentStage;
            // if the task is running in a cypress test, the correct answer should be indicated with 'correct' class
            if (window.Cypress && trialType !== 'something-same-1') {
                const responseBtns = document.querySelectorAll('.image-medium');
                responseBtns.forEach((button) => {
                    var _a;
                    const imgAlt = (_a = button.querySelector('img')) === null || _a === void 0 ? void 0 : _a.getAttribute('alt');
                    if (imgAlt === (0, taskStore_1.taskStore)().nextStimulus.answer) {
                        button.classList.add('correct');
                    }
                });
            }
            if (stimulus.trialType === 'something-same-2' && (0, taskStore_1.taskStore)().heavyInstructions) {
                (0, staggerButtons_1.handleStaggeredButtons)(pageStateHandler, buttonContainer, [
                    'same-different-selection-highlight-1',
                    'same-different-selection-highlight-2',
                ]);
            }
            if (trialType === 'test-dimensions' ||
                (assessmentStage === 'practice_response' && trialType !== 'something-same-1')) {
                // cards should give feedback during test dimensions block
                const practiceBtns = Array.from(buttonContainer.children)
                    .map((btnDiv) => btnDiv.firstChild)
                    .filter((btn) => !!btn);
                practiceBtns.forEach((card, i) => {
                    const eventType = taskSetup_1.isTouchScreen ? 'touchend' : 'click';
                    card.addEventListener(eventType, (e) => {
                        handleButtonFeedback(card, practiceBtns, false, i, 'feedbackGoodJob');
                    });
                });
            }
            (0, displayDebugInfo_1.displayDebugInfo)(stimulus);
        },
        on_finish: (data) => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const choices = (0, taskStore_1.taskStore)().choices;
            const endTime = performance.now();
            const cat = (0, taskStore_1.taskStore)().runCat;
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
            });
            // Always need to write correct key because of firekit.
            // TODO: Discuss with ROAR team to remove this check
            if (stim.assessmentStage !== 'instructions') {
                let isCorrect;
                if (stim.trialType === 'test-dimensions' || stim.assessmentStage === 'practice_response') {
                    // if no incorrect answers were clicked, that trial is correct
                    isCorrect = incorrectPracticeResponses.length === 0;
                }
                else {
                    isCorrect = data.button_response === (0, taskStore_1.taskStore)().correctResponseIdx;
                }
                incorrectPracticeResponses = [];
                // update task store
                (0, taskStore_1.taskStore)('isCorrect', isCorrect);
                if (isCorrect === false) {
                    taskStore_1.taskStore.transact('numIncorrect', (oldVal) => oldVal + 1);
                }
                else {
                    (0, taskStore_1.taskStore)('numIncorrect', 0);
                }
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    // specific to this trial
                    item: stim.item,
                    answer: stim.answer,
                    correct: isCorrect,
                    distractors: stim.distractors,
                    corpusTrialType: stim.trialType,
                    response: choices[data.button_response],
                    responseLocation: data.button_response,
                    itemUid: stim.itemUid,
                    audioFile: stim.audioFile,
                    corpus: (0, taskStore_1.taskStore)().corpus,
                });
                if ((0, taskStore_1.taskStore)().storeItemId) {
                    taskSetup_1.jsPsych.data.addDataToLastTrial({
                        itemId: stim.itemId,
                    });
                }
                if (stim.trialType === 'test-dimensions' || stim.assessmentStage === 'practice_response') {
                    const calculatedRt = Math.round(endTime - startTime);
                    taskSetup_1.jsPsych.data.addDataToLastTrial({
                        rt: calculatedRt,
                    });
                }
                if (stim.assessmentStage === 'test_response') {
                    taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
                }
                // if heavy instructions is true, show data quality screen before ending
                if ((0, taskStore_1.taskStore)().numIncorrect >= (0, taskStore_1.taskStore)().maxIncorrect && !(0, taskStore_1.taskStore)().heavyInstructions && !cat) {
                    (0, trials_1.finishExperiment)();
                }
                if (stim.trialType !== 'something-same-1' && stim.trialType !== 'instructions') {
                    (0, helpers_2.updateTheta)(stim, isCorrect);
                }
                if (cat && !(stim.assessmentStage === 'practice_response')) {
                    (0, helpers_1.shouldTerminateCat)();
                    const allSequentialTrials = (0, taskStore_1.taskStore)().sequentialTrials;
                    const nextTrials = allSequentialTrials.filter((trial) => {
                        return trial.trialNumber === stim.trialNumber && trial.trialType === stim.trialType;
                    });
                    (0, helpers_1.selectNextSequentialTrial)(nextTrials);
                }
            }
            if (stim.trialType === 'test-dimensions' || stim.assessmentStage === 'practice_response') {
                const calculatedRt = Math.round(endTime - startTime);
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    rt: calculatedRt,
                });
            }
            if (stim.assessmentStage === 'test_response') {
                taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
            }
        },
    };
};
exports.legacyStimulus = legacyStimulus;
